import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enNav from './locales/en/nav.json';
import enInstances from './locales/en/instances.json';
import enDocuments from './locales/en/documents.json';
import enQa from './locales/en/qa.json';
import enPrompts from './locales/en/prompts.json';
import enAudit from './locales/en/audit.json';
import enTenants from './locales/en/tenants.json';
import enAuth from './locales/en/auth.json';
import enErrors from './locales/en/errors.json';
import enDebug from './locales/en/debug.json';
import enAgent from './locales/en/agent.json';

import itCommon from './locales/it/common.json';
import itNav from './locales/it/nav.json';
import itInstances from './locales/it/instances.json';
import itDocuments from './locales/it/documents.json';
import itQa from './locales/it/qa.json';
import itPrompts from './locales/it/prompts.json';
import itAudit from './locales/it/audit.json';
import itTenants from './locales/it/tenants.json';
import itAuth from './locales/it/auth.json';
import itErrors from './locales/it/errors.json';
import itDebug from './locales/it/debug.json';
import itAgent from './locales/it/agent.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['it', 'en'],
    defaultNS: 'common',
    resources: {
      en: {
        common: enCommon, nav: enNav, instances: enInstances,
        documents: enDocuments, qa: enQa, prompts: enPrompts,
        audit: enAudit, tenants: enTenants, auth: enAuth, errors: enErrors, debug: enDebug, agent: enAgent,
      },
      it: {
        common: itCommon, nav: itNav, instances: itInstances,
        documents: itDocuments, qa: itQa, prompts: itPrompts,
        audit: itAudit, tenants: itTenants, auth: itAuth, errors: itErrors, debug: itDebug, agent: itAgent,
      },
    },
    interpolation: { escapeValue: false },
    detection: {
      order: ['navigator'],
    },
  });

export default i18n;
